import { useRef, useState } from 'react';

import { LoadingModal } from '../../../../components/LoadingModal/LoadingModal';
import { ExportCSV } from '../ExportCSV/ExportCSV';

export const ExportCustomers = ({
  filters,
}: {
  filters?: {
    status?: string | null;
    stage?: string | null;
    searchQuery?: string;
  };
}) => {
  const [requestId, setRequestId] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const controllerRef = useRef<AbortController | null>(null);

  return (
    <>
      <ExportCSV
        fetcher={({ stateKey }) => {
          controllerRef.current = new AbortController();
          const abortSignal = controllerRef.current.signal;
          setRequestId((prev) => prev + 1);
          // eslint-disable-next-line iwoca/prefer-lapi-client
          return fetch(
            `/api/iwocapay/seller/${stateKey}/customers_download/?` +
              new URLSearchParams({
                ...(filters?.stage && { application_stage: filters.stage }),
                ...(filters?.status && {
                  spending_limit_status: filters.status,
                }),
                ...(filters?.searchQuery && {
                  search: filters.searchQuery,
                  search_fields: 'company_name',
                }),
              }),
            { signal: abortSignal },
          );
        }}
        setIsLoading={setIsLoading}
      />
      <LoadingModal
        key={requestId}
        isOpen={isLoading}
        onClose={() => {
          controllerRef.current?.abort();
          setIsLoading(false);
        }}
        dismissable
        title="We’re getting your export ready"
        subText="Since you’re exporting a large file this might take longer than usual."
        tip="You can speed things up next time by applying more filters."
      />
    </>
  );
};
